<template>
  <v-button
    type="button"
    :disabled="disabled"
    class="btn btn-gray w-full"
    @click="c2a()"
  >
    <i class="mdi mdi-open-in-new mr-2" />
    {{ article.c2a_text }}
  </v-button>

  <p
    v-if="article.c2a_points_number"
    class="mt-1 text-sm text-center text-gray-500"
  >
    <i class="mdi mdi-information-outline" /> Clicking on the link will give you {{ article.c2a_points_number }} points
  </p>
</template>
<script>
export default {
  name: "v-claim-c2a",
  props: {
    article: {
      type: Object,
      required: true
    },
    readingTime: {
      required: true,
      type: Number
    }
  },
  emits: ["success"],
  data () {
    return {
      loading: false,
    };
  },
  computed: {
    disabled () {
      return !this.article.read && this.readingTime < this.article.minimum_reading_time;
    }
  },
  methods: {
    c2a() {
      if (this.disabled) {
        return ;
      }

      if (this.article.can.claim_c2a_points) {
        this.claim();
      }

      window.open(this.article.c2a_url,"_blank");
    },
    claim() {
      this.loading = true;
      this.$http.post(this.$laravel.route("api.articles.claim_c2a",{article: this.article.id}))
        .then((response) => {
          this.$notificator.success(response.data.message);
          this.$emit("success",response);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
